// CONTENT TYPES
export const Post = "post";
export const Reel = "reel";
// POST TYPES
export const Tweet = "tweet";
export const Video = "video";
export const Image = "image";
export const Audio = "audio";
export const Poll = "poll";
export const YoutubeVid = "youtube";

// MAIN COLLECTION
export const USERS = "users";
// MODALS
export const FOLLOWERS = "followers";
export const FOLLOWING = "following";
export const LIKES = "likes";
export const MUTUALFRIENDS = "mutual friends";
export const NEWUSERS = "new members";
export const BIRTHDAYS = "birthdays";

// FONTS
export const availableFonts = {
     RALEWAY: "Raleway",
     DOSIS: "Dosis",
     ARIAL: "'Segoe UI', Arial, sans-serif",
     Monospace: "'Courier New', monospace",
     HELVETICA: "Helvetica, sans-serif",
     VERDANA: "Verdana, sans-serif",
     ROMAN: "'Times New Roman', serif",
     GORGIA: "Georgia, serif"
}

// store reducers names
export const reducers = {
     MODALS: "modals",
     USERSLIST: "userList"
}